import Cookies from "js-cookie";

export function getDomain() {
  let domain = ".captyn.com";

  if (process.env.NEXT_PUBLIC_STAGE === "demo") {
    domain = ".nytpac.com";
  }

  if (process.env.NEXT_PUBLIC_STAGE === "test") {
    domain = window.location.hostname;
  }

  if (process.env.NODE_ENV === "development") {
    if (!window.location.hostname.includes(".local.localhost")) {
      domain = "localhost";
    } else {
      domain = ".local.localhost";
    }
  }

  return domain;
}

export function getToken() {
  const domain = getDomain();

  const cookieConfig = {
    domain,
  };

  let token = Cookies.get("accessToken", cookieConfig);

  if (
    !token &&
    window.sessionStorage.getItem("kiosk") &&
    window.sessionStorage.getItem("kiosk") !== "true"
  ) {
    token = window.sessionStorage.getItem("kiosk");
  }

  if (
    Cookies.get("viewingAs", cookieConfig) &&
    Cookies.get("viewingAsToken", cookieConfig)
  ) {
    token = Cookies.get("viewingAsToken", cookieConfig);
  }

  return token;
}

export function removeToken() {
  const domain = getDomain();

  const cookieConfig = {
    domain,
  };

  Cookies.remove("accessToken", cookieConfig);

  if (
    Cookies.get("viewingAs", cookieConfig) &&
    Cookies.get("viewingAsToken", cookieConfig)
  ) {
    Cookies.remove("viewingAs", cookieConfig);
    Cookies.remove("viewingAsToken", cookieConfig);
  }
}

export function setToken(token) {
  const expires = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
  const domain = getDomain();

  const cookieConfig = {
    expires,
    domain,
  };

  Cookies.set("accessToken", token, cookieConfig);
}

export function setViewAsToken(args: {
  viewingAs: string;
  viewingAsToken: string;
  returnPathname: string;
}) {
  const expires = new Date(new Date().getTime() + 60 * 60 * 1000);
  const domain = getDomain();

  const cookieConfig = {
    expires,
    domain,
  };

  Cookies.set("viewingAs", args.viewingAs, cookieConfig);
  Cookies.set("viewingAsToken", args.viewingAsToken, cookieConfig);
  Cookies.set("returnPathname", location.pathname, cookieConfig);
}

export function removeViewAsToken() {
  const domain = getDomain();

  const cookieConfig = {
    domain,
  };

  const returnPathname = Cookies.get("returnPathname", cookieConfig) || "/";

  Cookies.remove("viewingAs", cookieConfig);
  Cookies.remove("viewingAsToken", cookieConfig);
  Cookies.remove("returnPathname", cookieConfig);

  return returnPathname;
}
